<template>
  <a-card :bordered="false">
    <div>
      <a-button type="primary" @click="openModel">绑定商品</a-button>
    </div>
    <custom-page-table
      style="margin-top: 16px;"
      ref="table"
      :enableSearch="false"
      :requestPromise="loadPromise"
      :queryParams="allQueryParams"
      :columns="getColumns()"
    >
      <span slot="action" slot-scope="rowItem">
        <a-popconfirm title="是否要删除当前绑定？" @confirm="unbind(rowItem.record)">
          <a>删除绑定</a>
        </a-popconfirm>
        <a-divider type="vertical"/>
        <a @click.stop='onClickEditPro(rowItem.record)'>编辑</a>
      </span>
    </custom-page-table>
    <a-modal title="商品绑定" width="700px" :footer="null" :visible="visible" @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="currentFormLayout.labelCol"
                    :wrapper-col="currentFormLayout.wrapperCol">
        <a-form-model-item label="所属供应商" prop='supplierRelatedId'>
          <a-select v-model="ruleForm.supplierRelatedId" placeholder="请选择供应商">
            <a-select-option v-for="item in providerList" :key="item.id" :value="item.id">
              {{ item.supplierName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="关联商品" prop="proId">
          <a-button type="primary" @click="toSelectedProductEvent">选择商品</a-button>
          <span v-if="ruleForm.proId" style="margin-left: 3px;">商品ID:{{ ruleForm.proId }}</span>
          <span style="margin-left: 10px;">*仅能关联门票类型且未上架的自有商品</span>
        </a-form-model-item>
        <a-form-model-item v-if="ruleForm.proName" label="商品名称">
          <span style="margin-left: 10px;">{{ ruleForm.proName }}</span>
        </a-form-model-item>
        <a-form-model-item label="选择票型" prop="optionId">
          <a-select v-model="ruleForm.optionId" placeholder="请选择票型">
            <a-select-option v-for="item in optionList" :key="item.optionId" :value="item.optionId">
              {{ item.optionName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="供应商票型ID(商品编号)" prop="supplierOptionId">
          <a-input v-model="ruleForm.supplierOptionId" placeholder="请输入供应商票型ID(商品编号)"></a-input>
        </a-form-model-item>
        <a-form-model-item label="实名制类型" prop="realNameType">
          <a-select v-model="ruleForm.realNameType">
            <a-select-option :value="1">实名</a-select-option>
            <a-select-option :value="2">非实名</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="自动退票" prop="autoRefund">
          <a-radio-group v-model='ruleForm.autoRefund'>
            <a-radio :value="0">不支持</a-radio>
            <a-radio :value="1">支持</a-radio>
          </a-radio-group>
          <span v-if='ruleForm.autoRefund==1' style="color: red;">*仅随时退用户发起时可自动退票</span>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <a-button type="primary" :loading="submitLoading" @click="handleSubmit">保存设置</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal title="商品选择" width="900px" :footer="null" :visible="productVisible" @cancel="productCancel">
      <a-form layout="inline">
        <a-form-item label="商品ID">
          <a-input v-model="queryParams.proId" placeholder="请输入商品ID"></a-input>
        </a-form-item>
        <a-form-item label="商品名称">
          <a-input v-model="queryParams.proName" placeholder="请输入商品名称"></a-input>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="$refs.productList.refresh(true)">查询</a-button>
        </a-form-item>
      </a-form>
      <custom-page-table
        style="margin-top: 16px;"
        ref="productList"
        rowKey="proId"
        query-path="directTickets/bind/selectProList"
        base-key="directTicketsUrl"
        :queryParams="queryParams"
        :columns="getColumnsProduct()"
      >
        <span slot="index" slot-scope="rowItem">{{ rowItem.index + 1 }}</span>
        <span slot="action" slot-scope="rowItem">
          <a @click="onSourceItemClick(rowItem.record)">选择</a>
        </span>
      </custom-page-table>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'ZhiyoubaoConnection',
  data() {
    return {
      currentFormLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 },
        offsetCol: { offset: 7 }
      },
      submitLoading: false,
      queryParams: {
        catalogId: 1,
        merchantId: this.$store.getters.userInfo.merchantId,
        source: 0,
        state: 0
      },
      allQueryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        bindType: 3
      },
      loadPromise: params => this.getListPromise(params),
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      visible: false,
      productVisible: false,
      ruleForm: {
        merchantId: this.$store.getters.userInfo.merchantId,
        supplierRelatedId: undefined, //: 关联账号Id(供应商Id)
        supplierOptionId: '', //供应商票型Id ,
        optionId: undefined, //票型Id ,
        proId: '', //商品ID ,
        realNameType: 1,//实名
        autoRefund: 0,
        proName: '',
        id: null,
        bindType: 3,
        optionName: '',
        supplierProId: ''
      },
      rules: {
        supplierRelatedId: [
          { required: true, message: '请选择供应商', trigger: 'change' }
        ],
        proId: [
          { required: true, message: '请选择商品ID', trigger: 'change' }
        ],
        optionId: [
          { required: true, message: '请选择票型', trigger: 'change' }
        ],
        supplierOptionId: [
          { required: true, message: '请输入供应商票型ID(商品编号)', trigger: 'blur' }
        ]
      },
      providerList: [],
      optionList: []
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'zhiyoubaoConnection', title: '商品绑定' },
      { name: 'zybOrderConnection', title: '订单直连' },
      { name: 'zybRelationAccount', title: '关联账号' }
    ])
  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getDirectTicketsService().post('directTickets/bind/selectBindProList', params)
    },
    //选择商品
    toSelectedProductEvent() {
      this.productVisible = true
    },
    //商品数据点击
    onSourceItemClick(item) {
      this.getOptionList(item.proId, 0)
      this.ruleForm.optionId = undefined
      this.ruleForm.proId = item.proId
      this.$refs.ruleForm.validateField('proId', (Error) => {
      })
      this.ruleForm.proName = item.proName
      this.productVisible = false
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    // 绑定商品
    submitData() {
      let params = JSON.parse(JSON.stringify(this.ruleForm))
      this.submitLoading = true
      let optionName = this.optionList.filter(item => params.optionId == item.optionId)[0].optionName
      params.optionName = optionName
      this.getLogUtils().logWithTag('params', params)
      this.getHttpServices().getDirectTicketsService().post('directTickets/bind/saveBindPro', params).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.visible = false
        this.$message.success('商品绑定成功')
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    //解除绑定
    unbind(item) {
      let params = {
        merchantId: this.merchantId,
        id: item.id,
        bindType: 3,
        optionId: item.optionId,
        proId: item.proId
      }
      this.getHttpServices().getDirectTicketsService().post('directTickets/bind/deleteBindPro', params)
        .then(res => {
          this.$message.success('解除成功')
          this.$refs.table.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getOptionList(proId, optionId) {
      this.getHttpServices().getDirectTicketsService()
        .post('directTickets/bind/selectOptionList?pageNum=1&pageSize=9999&proId=' + proId + '&optionId=' + optionId)
        .then(res => {
          this.optionList = res.data
          //this.ruleForm.optionId = undefined
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //获取供应商列表
    getProviderList() {
      this.getHttpServices().getDirectTicketsService().post('directTickets/related/selectAccountDropDownList', {
        merchantId: this.merchantId,
        relatedType: 3,
        state: 1
      }).then(res => {
        this.providerList = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    productCancel() {
      this.productVisible = false
    },
    onClickEditPro(record) {
      this.visible = true
      this.getProviderList()
      this.getOptionList(record.proId, record.optionId)
      this.getQueryBindPro(record.id)
    },
    getQueryBindPro(bindId) {
      const params = {
        bindId: bindId
      }
      this.getHttpServices().getDirectTicketsService().get('directTickets/bind/queryBindPro', params)
        .then(res => {
          if (res) {
            this.ruleForm = {
              ...res,
              bindType: 3,
              merchantId: this.merchantId
            }
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    openModel() {
      this.visible = true
      this.ruleForm = {
        supplierRelatedId: undefined, //: 关联账号Id(供应商Id)
        supplierOptionId: '', //供应商票型Id ,
        optionId: undefined, //票型Id ,
        proId: '', //商品ID ,
        realNameType: 1,//实名
        autoRefund: 0,
        proName: '',
        id: null,
        bindType: 3,
        merchantId: this.merchantId,
        optionName: '',
        supplierProId: ''
      }
      this.getProviderList()
    },
    handleCancel() {
      this.visible = false
    },
    getColumns() {
      return [
        {
          title: '商品ID',
          dataIndex: 'proId'
        },
        {
          title: '商品名称',
          dataIndex: 'proName',
          width: '24%'
        },
        {
          title: '票型',
          dataIndex: 'optionName'
        },
        {
          title: '类型',
          dataIndex: 'catalogName'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime'
        },
        {
          title: '供应商名称',
          dataIndex: 'supplierName'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '140px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    getColumnsProduct() {
      return [
        {
          title: '序号',
          dataIndex: 'index',
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '商品ID',
          dataIndex: 'proId'
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }
}
</script>
<style scoped></style>

